import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
    return (
        <nav className="w-full bg-black bg-opacity-70 backdrop-blur-md shadow-lg fixed top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="flex-shrink-0 text-xl font-bold text-white tracking-wide">
                        <Link to="/">MEMEX-AI</Link>
                    </div>
                    <div className="flex items-center space-x-4">
                        <Link
                            to="/login"
                            className="px-3 py-1 border border-cyan-400 text-cyan-400 hover:bg-cyan-500 hover:text-white rounded-md text-sm transition-all"
                        >
                            Login
                        </Link>
                        <Link
                            to="/register"
                            className="px-3 py-1 bg-cyan-500 hover:bg-cyan-600 text-white rounded-md text-sm font-medium shadow"
                        >
                            Register
                        </Link>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
